class Lightbox {
    // 1. describe and create/initiate our object
    constructor() {
        this.gallery = document.querySelector('.giveaways__gallery');
        if (this.gallery) {
            this.slides = this.gallery.querySelectorAll('.giveaways__gallery-image');
        }
        this.galleryModal = document.querySelector('.giveaways__gallery-modal');
        this.galleryClose = document.querySelector('.close-modal');

        if (this.gallery && this.slides && this.galleryClose) {
            this.events();
        }
    }
    events() {
        this.slides.forEach(slide => {
            slide.addEventListener('click', () => {
                this.galleryModal.classList.add("opened");
                this.checkGalleryState();
            })
        });

        this.galleryClose.addEventListener('click', () => {
            this.galleryModal.classList.remove("opened");
            this.checkGalleryState();
        });
        document.addEventListener('keydown', (event) => {
            if (event.key == "Escape") {
                this.galleryModal.classList.remove("opened");
                this.checkGalleryState();
            }
        });

        this.galleryModal.addEventListener('click', (e) => {
            if(e.target.contains(this.galleryModal)) {
                this.galleryModal.classList.remove("opened");
                this.checkGalleryState();
            }
        })
    }

    checkGalleryState() {
        if (this.galleryModal.classList.contains("opened")) {
    
            document.addEventListener('keydown', (event) => {
                if (event.key == "ArrowUp" || event.key == "ArrowDown") {
                    if (!this.galleryModal.classList.contains('opened')) {
                        return true;
                    }
                    else {
                        event.preventDefault();
                    }
                }
            });
        }
    }
}
export default Lightbox;
